import { GET_STATES_REQUEST, GET_STATES_SUCCESS, GET_STATES_ERROR } from '../types';
export const getStatesRequest = () => {
  return {
    type: GET_STATES_REQUEST
  };
};
export const getStatesSuccess = () => {
  return {
    type: GET_STATES_SUCCESS
  };
};
export const getStatesError = error => {
  return {
    type: GET_STATES_ERROR,
    error: true,
    payload: error
  };
};
export const getStates = options => {
  const {
    countryIso
  } = options;
  return async (dispatch, _, _ref) => {
    let {
      chord
    } = _ref;
    try {
      dispatch(getStatesRequest());
      const states = await chord.oms.getCountryStates(countryIso);
      dispatch(getStatesSuccess());
      return states;
    } catch (error) {
      dispatch(getStatesError(error));
      throw error;
    }
  };
};